import { NgModule } from "@angular/core";
import { SafeHtml } from "../../modules/shared/pipes/safeHtml.pipe";
import { Humanize } from "../../modules/shared/pipes/humanizeText.pipe";
import { SearchPipe } from "../../modules/shared/pipes/searchFilter.pipe";

@NgModule({
    imports: [
        // dep modules
    ],
    declarations: [SafeHtml, Humanize, SearchPipe],
    exports: [SafeHtml, Humanize, SearchPipe]
})
export class SharedModule {}
